
import Vue, { VueConstructor } from 'vue'
import Widget, { WidgetProps } from '@/components/Widget.vue'

export interface WidgetGroupProps {
  widgets: WidgetProps[]
}

export default Vue.extend<WidgetGroupProps>({
  functional: true,
  props: {
    widgets: {
      type: Array,
      default: () => []
    }
  },
  render (h, context) {
    const { widgets } = context.props
    return widgets
      .map((widget, i) =>
        h(Widget, {
          props: widget,
          key: i
        })
      )
  }
})
